export enum SUPPORTED_LANGUAGES {
  EN = "en",
  ES = "es",
  FR = "fr",
  JA = "ja",
}

export const FALLBACK_LANGUAGE = SUPPORTED_LANGUAGES.EN;

export const LOCALE_MAP: {
  [key in SUPPORTED_LANGUAGES]: () => Promise<ILocale>;
} = {
  [SUPPORTED_LANGUAGES.EN]: () => import("dayjs/locale/en"),
  [SUPPORTED_LANGUAGES.ES]: () => import("dayjs/locale/es"),
  [SUPPORTED_LANGUAGES.FR]: () => import("dayjs/locale/fr"),
  [SUPPORTED_LANGUAGES.JA]: () => import("dayjs/locale/ja"),
};
